import { render, staticRenderFns } from "./DropdownOptionsExportarRelatorio.vue?vue&type=template&id=171edc7e&lang=pug"
import script from "./DropdownOptionsExportarRelatorio.vue?vue&type=script&lang=js"
export * from "./DropdownOptionsExportarRelatorio.vue?vue&type=script&lang=js"
import style0 from "./DropdownOptionsExportarRelatorio.vue?vue&type=style&index=0&id=171edc7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports